module.exports = __webpack_public_path__ + "img/undraw_personal_data_29co.c8684e91.svg";